export const TEMPLATE_NAMES = {
  DRM_DEALER_LIST: "drm-dealer-list-template.xlsx",
};
